import { Box, Dialog, DialogContent, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useContext, useEffect, useMemo, useState } from "react"
import { addIdForDataGrid, sortObj } from "utils"
import { expenseDetailColumns } from "./columns"
import { addSumRow, getSumColorClassName, sxSumColorClass } from "utils/highlightSumColor"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { blue, green } from "@mui/material/colors"

const modSxSumColorClass = {
  ...sxSumColorClass,
  '& .cell-green': { bgcolor: green[50] },
  '& .cell-blue': { bgcolor: blue[50] },
}
const ExpenseDetailDialog = ({ dialogOpen, setDialogOpen, selectedRow }) => {

  const { ax } = useContext(GlobalStateContext)
  const [scDataTable, setScDataTable] = useState([])
  const [itmDataTable, setItmDataTable] = useState([])
  const [invDataTable, setInvDataTable] = useState([])

  const scDataTableMemo = useMemo(() => {
    return sortObj(addSumRow({
      dataTable: scDataTable,
      sumColNms: ["Total"],
      sumColTotal: "ExpNm"
    }), "IsOwnRcpt")
  }, [scDataTable])

  const itmDataTableMemo = useMemo(() => {
    return sortObj(addSumRow({
      dataTable: itmDataTable,
      sumColNms: ["Total"],
      sumColTotal: "ExpNm"
    }), "IsOwnRcpt")
  }, [itmDataTable])

  const invDataTableMemo = useMemo(() => {
    return sortObj(addSumRow({
      dataTable: invDataTable,
      sumColNms: ["Total"],
      sumColTotal: "ExpNm"
    }), "IsOwnRcpt")
  }, [invDataTable])

  useEffect(() => {
    if (dialogOpen) {
      setScDataTable(addIdForDataGrid(selectedRow?.ScExps || [], 'ScExpId'))
      setItmDataTable(addIdForDataGrid(selectedRow?.Itms || [], 'PCItmId'))
      setInvDataTable(addIdForDataGrid(selectedRow?.Exps || [], 'ExpJobOrdId'))
    } else {
      setScDataTable([])
      setItmDataTable([])
      setInvDataTable([])
    }
  }, [dialogOpen, ax, selectedRow])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='lg'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="รายละเอียดค่าใช้จ่าย"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFR pt={2} width="100%">
          <BoxFC sx={{ alignItems: 'center', gap: 0 }} width={400}>
            <Typography fontWeight="bold">รถร่วม</Typography>
            <Box height={600} sx={modSxSumColorClass} width="100%">
              <DataGridCellExpand
                hideFooter
                rows={scDataTableMemo}
                columns={expenseDetailColumns}
                getRowClassName={getSumColorClassName}
                experimentalFeatures={{ rowPinning: true }}
                pinnedRows={{ bottom: [scDataTableMemo.find(row => row.id === 0)] }}
              />
            </Box>
          </BoxFC>
          <BoxFC sx={{ alignItems: 'center', gap: 0 }} width={400}>
            <Typography fontWeight="bold">เงินสดย่อย</Typography>
            <Box height={600} sx={modSxSumColorClass} width="100%">
              <DataGridCellExpand
                hideFooter
                rows={itmDataTableMemo}
                columns={expenseDetailColumns}
                getRowClassName={getSumColorClassName}
                experimentalFeatures={{ rowPinning: true }}
                pinnedRows={{ bottom: [itmDataTableMemo.find(row => row.id === 0)] }}
              />
            </Box>
          </BoxFC>
          <BoxFC sx={{ alignItems: 'center', gap: 0 }} width={400}>
            <Typography fontWeight="bold">รายได้</Typography>
            <Box height={600} sx={modSxSumColorClass} width="100%">
              <DataGridCellExpand
                hideFooter
                rows={invDataTableMemo}
                columns={expenseDetailColumns}
                getRowClassName={getSumColorClassName}
                experimentalFeatures={{ rowPinning: true }}
                pinnedRows={{ bottom: [invDataTableMemo.find(row => row.id === 0)] }}
              />
            </Box>
          </BoxFC>
        </BoxFR>
      </DialogContent>
      <DialogFooter okText={""}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null} />
    </Dialog>
  )
}

export default React.memo(ExpenseDetailDialog)